import { Container, SectionTitle, YoutubeGallery } from '@sloyd/ui';
import { Json } from '../../types';
import { Wrapper } from './ContentMadeWithSloyd.style';

export type ContentMadeWithSloydProps = {
  clips: Json[];
};

export function ContentMadeWithSloyd(props: ContentMadeWithSloydProps) {
  const { clips } = props;

  return (
    <Wrapper className='ContentMadeWithSloyd-wrapper' data-testid='ContentMadeWithSloyd-wrapper'>
      <Container>
        <SectionTitle gradient={{ from: '#7f00ff', to: '#e100ff' }} title='✨ Made with Sloyd'>
          Get inspired by creations <strong>made with Sloyd</strong>and then brought to life in
          Unity.
        </SectionTitle>
        <YoutubeGallery clips={clips} />
      </Container>
    </Wrapper>
  );
}

export default ContentMadeWithSloyd;
